import ResultSolutionSummary from './ResultSolutionSummary';

export default ResultSolutionSummary;
